import React, { useState } from 'react';
import './Login.css';
import api from '../services/api';

const getLoginContext = () => {
  if (typeof window === 'undefined') {
    return { title: 'School Login', subtitle: 'Welcome back! Please sign in to your account' };
  }

  const path = window.location.pathname || '';

  if (path.includes('/parent')) {
    return {
      title: 'Parent Login',
      subtitle: 'Parents portal - sign in to track your child'
    };
  }

  if (path.includes('/admin')) {
    return {
      title: 'Admin Login',
      subtitle: 'Administrative access - secure area'
    };
  }

  if (path.includes('/agency')) {
    return {
      title: 'Agency Login',
      subtitle: 'Agency portal - manage multiple schools'
    };
  }

  if (path.includes('/teacher')) {
    return {
      title: 'Class Teacher Login',
      subtitle: 'Assign devices and check student device status'
    };
  }

  return {
    title: 'School Login',
    subtitle: 'School staff portal - manage routes and attendance'
  };
};

const Login = () => {
  
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    userType: 'school'
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Determine user type based on URL
      const path = window.location.pathname;
      let userType = 'school'; // default
      
      if (path.includes('/parent')) {
        userType = 'parent';
      } else if (path.includes('/admin')) {
        userType = 'admin';
      } else if (path.includes('/agency')) {
        userType = 'agency';
      } else if (path.includes('/teacher')) {
        userType = 'teacher';
      }
      
      const response = await api.login(userType, formData.email, formData.password);
      
      api.setAuthToken(response.token);
      
      const userData = {
        ...response.user,
        user_type: response.user.role
      };
      
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('userLogin', { detail: userData }));
      }
      
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const { title: loginTitle, subtitle: loginSubtitle } = getLoginContext();

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="logo">
            <img src="/logo.png" alt="EduManage logo" className="logo-img" />
          </div>
          <h1 className="logo-title">{loginTitle}</h1>
          <p className="subtitle">{loginSubtitle}</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Email Address</label>
            <div className="input-wrapper">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Password</label>
            <div className="input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>



          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="login-btn" 
            disabled={loading}

          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Signing In...
              </>
            ) : (
              'Sign In'
            )}
          </button>
        </form>

        <div className="login-footer">
          <a href="#" className="forgot-password">Forgot Password?</a>
          <div style={{ textAlign: 'center', marginTop: '10px' }}>
            <button 
              type="button" 
              className="back-btn"
              onClick={() => window.location.href = '/'}
              style={{
                background: 'none',
                border: 'none',
                color: '#666',
                cursor: 'pointer',
                fontSize: '14px',
                textDecoration: 'underline'
              }}
            >
              ← Back to Login Selection
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;